@if (selectMultiple) {
  <mat-checkbox
    class="checkbox"
    [checked]="checked"
    [matTooltip]="checkboxTooltip"
    [matTooltipDisabled]="!checkboxTooltip"
    [(ngModel)]="checked"
    (click)="onCheckboxClick($event)"
  ></mat-checkbox>
}

@if (libRETemplate) {
  <mat-icon color="primary" class="icon">add_box</mat-icon>
} @else {
  @if (hasImage) {
    <img class="image" [src]="imageSrc" [alt]="imageAlt" />
  } @else {
    <app-placeholder-image class="image" [index]="index"></app-placeholder-image>
  }
}

<div class="info">
  <div class="title">
    <label>
      <ng-content></ng-content>
    </label>

    @if (titleActionTemplate) {
      <div class="title-action">
        <ng-template [ngTemplateOutlet]="titleActionTemplate"></ng-template>
      </div>
    }
  </div>

  @if (details && description) {
    <div class="desc app-markdown" [innerHTML]="description"></div>
  }
</div>
